import { View } from "@react-pdf/renderer";
import {


} from "components/Resume/ResumePDF/common";
import { styles } from "components/Resume/ResumePDF/styles";
import type { ResumeSkills } from "lib/redux/types";
import { ResumePDFDescription, TemplateTwelvePDFSection } from "./common";

export const Skills = ({
  heading,
  skills,
  themeColor,
}: {
  heading: string;
  skills: ResumeSkills;
  themeColor: string;
}) => {
  const { descriptions } = skills;
  return (
    <TemplateTwelvePDFSection themeColor={themeColor} heading={heading}>
      <View  style={{ ...styles.flexCol }} wrap={false}>
        <ResumePDFDescription  items={descriptions} themeColor={themeColor} />
      </View>
    </TemplateTwelvePDFSection>
  );
};
